import { setCourseQueryData } from '@/actions/courses';
import CustomCheckBox from '@/components/CustomCheckBox';
import useWidth from '@/helpers/widthUtil';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Drawer, Skeleton } from 'antd';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const CourseSidebar = ({
  loading,
  total,
  searchDrawer,
  setSearchDrawer,
  summary,
}) => {
  const { isMobile } = useWidth();
  const router = useRouter();
  const dispatch = useDispatch();
  const currentPath = router.pathname;
  const currentQuery: any = router.query;

  const [catgeory, setCatgeory] = useState(null);
  const [feetype, setFeeType] = useState(null);
  const [sort, setSort] = useState(null);

  const SLICE_COUNT = 2;
  const [catToShow, setCatToShow] = useState(SLICE_COUNT);

  const dataSidebar = {
    categories: summary?.category,
  };
  const courseQuery = useSelector((state: any) => state?.courses?.query?.courses);

  useEffect(() => {
    if (dataSidebar?.categories?.length > 0) {
      // Check checkbox if query is present in url
      const matchTest = dataSidebar?.categories?.indexOf(currentQuery?.test);
      const matchFee = dataSidebar?.categories?.indexOf(currentQuery?.is_free);
      matchTest === -1 ? setCatgeory(currentQuery?.test) : setCatgeory(null);
      if (matchFee === -1) {
        if (currentQuery?.is_free == 'true') {
          setFeeType('free');
        } else if (currentQuery?.is_free == 'false') {
          setFeeType('paid');
        }
      } else {
        setFeeType(null);
      }
    }
  }, [dataSidebar?.categories]);

  useEffect(() => {
    if (!currentQuery?.test) {
      delete currentQuery.test;
    }
    if (!currentQuery?.sort) {
      delete currentQuery.sort;
    }
    router.push(
      {
        pathname: currentPath,
        query: currentQuery,
      },
      undefined,
      { scroll: false }
    );
  }, [catgeory, feetype, sort]);

  const onChange = (e, key, value) => {
    if (key == 'sort') {
      setSort(e.target.checked ? value : null);
      if (e.target.checked) {
        currentQuery.sort = value;
      }
    }
    if (key == 'catgeory') {
      setCatgeory(e.target.checked ? value : null);
      if (e.target.checked) {
        currentQuery.test = value;
      }
    }
    if (key == 'course_type') {
      setFeeType(e.target.checked ? value : null);
      if (
        value ||
        (router?.query?.course_type || '') === 'free' ||
        value ||
        (router?.query?.course_type || '') === 'paid'
      ) {
        currentQuery.course_type = value;
        router.push(
          {
            pathname: currentPath,
            query: currentQuery,
          },
          undefined,
          { scroll: false }
        );
      }
    }

    if (!e.target.checked && key !== 'course_type') {
      if (!catgeory && !feetype) {
        router.push(
          {
            pathname: currentPath,
            query: '',
          },
          undefined,
          { scroll: false }
        );
      }
    } else {
      router.push(
        {
          pathname: currentPath,
          query: currentQuery,
        },
        undefined,
        { scroll: false }
      );
    }
    // else if (key == "price"){
    //     // setPrice(value);
    //     currentQuery.category = value
    // }
  };

  const resetFilter = () => {
    router.query = {};
    delete currentQuery?.name;

    setCatgeory(null);
    setFeeType(null);
    setSort(null);
    router.push(
      {
        pathname: currentPath,
        query: {},
      },
      undefined,
      { scroll: true }
    );
  };

  const SideBar = (
    <div>
      <div className="card shadow-none border border-0 mb-2">
        {!isMobile && (
          <div
            className="d-flex justify-content-start mb-3"
            // style={{ border: '2px solid #6d6e80' }}
          >
            <img src="/images/sort.svg" width={'32px'} height="auto" />
            <h6 className="text-secondary my-auto ml-2">Filters</h6>
          </div>
        )}
      </div>
      <div className="card p-0 shadow-none">
        {loading ? (
          <div className="d-flex justify-content-between gap-3">
            <Skeleton.Button active className="w-100" />
            <Skeleton.Button active className="w-100" />
          </div>
        ) : (
          <div className={`d-flex justify-content-center`}>
            <Button
              size={'middle'}
              // icon={<LoginOutlined rev="" className="float-right mt-1 ml-1" />}
              className={`btn-danger w-50 text-white border-danger montserrat-font-family`}
              style={{
                opacity:
                  feetype === null &&
                  router?.query?.course_type !== 'free' &&
                  router?.query?.course_type !== 'paid'
                    ? 1
                    : feetype || router?.query?.course_type === 'free'
                    ? 1
                    : 0.7,
              }}
              onClick={(e) => {
                onChange(e, 'course_type', 'free');
                dispatch(
                  setCourseQueryData({
                    name: 'courses',
                    value: {
                      ...courseQuery,
                      course_type: 'free',
                    },
                  })
                );
              }}
            >
              Free <span> ({summary?.free})</span>
              {/* ({summary?.free}) */}
            </Button>
            <Button
              size={'middle'}
              // icon={<LoginOutlined rev="" className="float-right mt-1 ml-1" />}
              className="btn-danger w-50 text-white border-danger ml-2 montserrat-font-family"
              style={{
                opacity:
                  feetype === null &&
                  router?.query?.course_type !== 'free' &&
                  router?.query?.course_type !== 'paid'
                    ? 1
                    : feetype || router?.query?.course_type === 'paid'
                    ? 1
                    : 0.7,
              }}
              onClick={(e) => {
                onChange(e, 'course_type', 'paid');
                dispatch(
                  setCourseQueryData({
                    name: 'courses',
                    value: {
                      ...courseQuery,
                      course_type: 'paid',
                    },
                  })
                );
              }}
            >
              Paid <span> ({summary?.paid})</span>
              {/* ({summary?.paid}) */}
            </Button>
          </div>
        )}

        <div>
          <h6 className="mt-3 mb-2 text-secondary">Sort By</h6>
          <div className="d-flex flex-column">
            <CustomCheckBox
              className="course-checkbox"
              label={
                <span className="text-capitalize text-black font-weight-500">
                  Latest
                </span>
              }
              overlaystyle={{ width: '16px', height: '16px' }}
            >
              <input
                type="checkbox"
                onChange={(e) => onChange(e, 'sort', 'latest')}
                checked={
                  sort === 'latest' || router?.query?.sort == 'latest' ? true : false
                }
              />
            </CustomCheckBox>
            <CustomCheckBox
              className="course-checkbox"
              label={
                <span className="text-capitalize text-black font-weight-500">
                  Oldest
                </span>
              }
              overlaystyle={{ width: '16px', height: '16px' }}
            >
              <input
                type="checkbox"
                onChange={(e) => onChange(e, 'sort', 'oldest')}
                checked={
                  sort === 'oldest' || router?.query?.sort == 'oldest' ? true : false
                }
              />
            </CustomCheckBox>
          </div>
        </div>
        <div
          className="mt-2"
          style={{
            borderTop: '1px solid #6a6c72',
            borderWidth: '2px',
          }}
        />
        <div>
          <h6 className="mt-3 mb-2 text-secondary">Course Categories</h6>
          <div className="d-flex flex-column">
            {dataSidebar?.categories?.length <= 2
              ? dataSidebar?.categories?.map((data, key) => (
                  <CustomCheckBox
                    key={key}
                    className="course-checkbox"
                    label={
                      <span className="text-capitalize text-black font-weight-500">
                        {data.name} ({data?.count})
                      </span>
                    }
                    overlaystyle={{ width: '16px', height: '16px' }}
                  >
                    <input
                      type="checkbox"
                      id={`${key}`}
                      onChange={(e) => onChange(e, 'catgeory', data.name)}
                      checked={
                        catgeory === data.name || router?.query?.test === data.name
                          ? true
                          : false
                      }
                    />
                  </CustomCheckBox>
                ))
              : dataSidebar?.categories?.slice(0, catToShow)?.map((data, key) => (
                  <CustomCheckBox
                    key={key}
                    className="course-checkbox"
                    label={
                      <span className="text-capitalize text-black font-weight-500">
                        {data.name} ({data?.count})
                      </span>
                    }
                    overlaystyle={{ width: '16px', height: '16px' }}
                  >
                    <input
                      type="checkbox"
                      id={`${key}`}
                      onChange={(e) => onChange(e, 'catgeory', data.name)}
                      checked={
                        catgeory === data.name || router?.query?.test === data.name
                          ? true
                          : false
                      }
                    />
                  </CustomCheckBox>
                ))}
          </div>
          {catToShow <= dataSidebar?.categories?.length && (
            <span
              className="cursor-pointer text-black font-weight-500"
              onClick={
                catToShow === SLICE_COUNT
                  ? () => setCatToShow(dataSidebar?.categories?.length)
                  : () => setCatToShow(SLICE_COUNT)
              }
            >
              {catToShow === SLICE_COUNT ? (
                <DownOutlined
                  rev=""
                  className="mr-1"
                  style={{ verticalAlign: '-2.15px' }}
                />
              ) : (
                <UpOutlined
                  rev=""
                  className="mr-1"
                  style={{ verticalAlign: '-2.15px' }}
                />
              )}
              Show {catToShow === SLICE_COUNT ? 'more' : 'less'}
            </span>
          )}
        </div>
        <Button
          size={'middle'}
          className="mt-2 mb-1 border-18 w-75 mx-auto"
          onClick={resetFilter}
        >
          <i className="fa fa-times mr-2"></i> Clear filters
        </Button>
      </div>
    </div>
  );

  return (
    <>
      {!isMobile ? (
        SideBar
      ) : (
        <Drawer
          title={
            <h6 className="text-white">
              {total} results{' '}
              {router?.query?.name &&
                router?.query?.name !== undefined &&
                `for  "${router?.query?.name}"`}
            </h6>
          }
          visible={searchDrawer}
          onClose={() => setSearchDrawer(false)}
          width="100%"
        >
          {SideBar}
        </Drawer>
      )}
    </>
  );
};

export default CourseSidebar;
